module.exports = __webpack_public_path__ + "532798c39b8267be9a9465f9f4124e4d.svg";